import { configureStore } from "@reduxjs/toolkit";
import cableEntryReducer from "../features/cableEntryData";
import homeFilterReducer from "../features/homeFilter";
import popupFilterReducer from "../features/popup";
import configuratorReducer from "../features/configurator";
import grommetsReducer from "../features/visibleGrommets";
import grommetsFilterReducer from "../features/grommetsFilter";
import accessoriesFilterReducer from "../features/accessoriesFilter";
import quoteReducer from "../features/quote";
import loaderReducer from "../features/loader";
import { productMasterApi } from "../../services/productMasterApi";
export const store = configureStore({
  reducer: {
    [productMasterApi.reducerPath]: productMasterApi.reducer,
    cableEntryData: cableEntryReducer,
    homeFilter: homeFilterReducer,
    popupFilter: popupFilterReducer,
    configurator: configuratorReducer,
    grommetsState: grommetsReducer,
    grommetsFilter: grommetsFilterReducer,
    accessoriesFilter: accessoriesFilterReducer,
    qoute: quoteReducer,
    loader: loaderReducer,
  },
  middleware: (getDefaultMiddleWare) =>
    getDefaultMiddleWare().concat(productMasterApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
